import React from 'react';
import { SegmentedControl } from '@spark';
import { OVERRIDE_MODES } from '../utils/specificAIOverrides';

/**
 * "Same as commercial | Empty | Customize" segmented control for one
 * SpecificAI tab section (Figma). "Empty" keeps the disable semantics:
 * nothing is sent to the SpecificAI model for that field (persisted as "").
 */
const OverrideModeControl = ({ mode, onChange, disabled = false, ariaLabel }) => (
    <SegmentedControl
        size="small"
        className="model-setup-override-mode fs-unmask"
        aria-label={ariaLabel}
        items={[
            { id: OVERRIDE_MODES.same, label: 'Same as commercial', disabled },
            { id: OVERRIDE_MODES.disable, label: 'Empty', disabled },
            { id: OVERRIDE_MODES.customize, label: 'Customize', disabled },
        ]}
        activeId={mode}
        onChange={(id) => onChange?.(id)}
    />
);

export default OverrideModeControl;
